import TableCategories from "./TableCategories";
export default TableCategories;
